<template>
  <div class="flex flex-col gap-y-9 bg-white px-3 py-4 lg:pb-16 lg:pt-[75px]">
    <div
      class="flex flex-col gap-y-9 lg:flex-row-reverse lg:items-center lg:justify-center lg:gap-x-44"
    >
      <div>
        <nav class="">
          <ul class="flex justify-center">
            <li class="">
              <a
                href="https://www.facebook.com/djurensratt"
                target="_blank"
                rel="noopener"
                class="group m-2 flex items-center justify-center rounded-full p-2 hover:bg-blue"
              >
                <span class="flex items-center justify-center">
                  <component
                    :is="`svgo-social-${'facebook'}`"
                    class="h-7 w-7 fill-blue group-hover:fill-white"
                  />
                </span>
              </a>
            </li>
            <li class="">
              <a
                class="group m-2 flex items-center justify-center rounded-full p-2 hover:bg-blue"
                href="https://www.instagram.com/djurensratt/"
                target="_blank"
                rel="noopener"
              >
                <component
                  :is="`svgo-social-${'instagram'}`"
                  class="h-7 w-7 fill-blue group-hover:fill-white"
                />
              </a>
            </li>
            <li class="">
              <a
                class="group m-2 flex items-center justify-center rounded-full p-2 hover:bg-blue"
                href="https://www.youtube.com/user/DjurensRatt"
                target="_blank"
                rel="noopener"
              >
                <component
                  :is="`svgo-social-${'youtube'}`"
                  class="h-7 w-7 fill-blue group-hover:fill-white"
                />
              </a>
            </li>
            <li class="">
              <a
                class="group m-2 flex items-center justify-center rounded-full p-2 hover:bg-blue"
                href="https://www.tiktok.com/@djurensratt"
                target="_blank"
                rel="noopener"
              >
                <component
                  :is="`svgo-social-${'tiktok'}`"
                  class="h-7 w-7 fill-blue group-hover:fill-white"
                />
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="flex items-center justify-center gap-x-9 px-16">
        <div class="w-16">
          <LogoSimple />
        </div>

        <div class="flex flex-col">
          <span class="font-serif text-lg uppercase leading-tight text-black">Kontakta oss</span>
          <a
            href="mailto:blixtapp@djurensratt.se"
            class="font-sans text-base text-blue hover:underline"
          >
            blixtapp@djurensratt.se
          </a>
        </div>
      </div>
    </div>

    <div class="text-center font-sans text-xs text-black lg:text-sm">
      Allt innehåll &copy; Djurens Rätt om inte annat anges.
      <span class="mx-1">|</span>
      <a
        href="https://djurensratt.se/integritet"
        target="_blank"
        rel="noopener"
        class="text-blue hover:underline"
        >Integritetspolicy</a
      >
    </div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { LogoSimple } from 'refresh-ui'
</script>
